// NATIVE 
import React, { useState } from 'react';



// INSTALLED 
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import { Formik, Form } from 'formik';
import Stepper from '@mui/material/Stepper';
import { Card, Divider } from '@mui/material';
import StepLabel from '@mui/material/StepLabel';



// CUSTOM 
import { mtDividerUpTable } from '../../commons';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import formInitialValues from '../../components/sucursal/formModels/formInitialValues';
import { DetailSucursalEmpresa } from '../../components/sucursal/DetailSucursalEmpresa';
import validationSchema from '../../components/empresa/editar/formModels/validationSchema';
import editSucursalFormModel from '../../components/sucursal/formModels/edit/editSucursalFormModel';




/**
 * DetalleSucursal component renders the detailed view of a branch (Sucursal).
 * It includes a breadcrumb navigation, a stepper for form steps, and a form
 * managed by Formik for handling form state and validation.
 *
 * @component
 * @example
 * return (
 *   <DetalleSucursal />
 * )
 *
 * @returns {JSX.Element} The rendered component.
 *
 * @remarks
 * - The component uses Material-UI components such as Box, Divider, Stepper, Step, and StepLabel.
 * - The form is managed using Formik and Yup for validation.
 * - The component is designed to handle multiple steps in the form, although currently, it only has one step.
 *
 * @see {@link https://material-ui.com/} for Material-UI documentation.
 * @see {@link https://formik.org/} for Formik documentation.
 * @see {@link https://github.com/jquense/yup} for Yup validation schema documentation.
 */
export const DetalleSucursal = () => {


    // FORM MODEL DATA 
    const { formId, formField } = editSucursalFormModel;


    // USE STATE 
    const [activeStep, setActiveStep] = useState(0);


    // SCHEMA 
    const steps: string[] = ['Detalle Sucursal'];
    const currentValidationSchema = validationSchema[activeStep];


    // CONST FUNCTIONS 
    const  _renderStepContent = (steps: any) => {
        switch (steps) {
          case 0:
            return <DetailSucursalEmpresa formField={formField} />;
        }
    }

    

    return (
        <Box sx={{ width: '100%' }}>
        


        <BreadCrumbsAndTitle
                title="Detalle Sucursal" 
                mainModule="configuracion" 
                parent="Listar Sucursal"
                action="/configuracion/sucursal" />
        
            <Divider sx={{ marginBottom: mtDividerUpTable }}/>


            <Stepper activeStep={activeStep}>
                {steps.map((label:any, index:any) => {
                const labelProps: {
                    optional?: React.ReactNode;
                    error?: boolean;
                    
                } = {};

                return (
                    <Step key={label}>
                    <StepLabel  {...labelProps}>{label}</StepLabel>
                    </Step>
                );
                })}
            </Stepper>

            <Formik
                initialValues={formInitialValues}
                validationSchema={currentValidationSchema}
                onSubmit={ () => console.log()}
                >

                <Card style={{ marginTop: 50,  padding: 20}}>
                    <Form id={formId}>
                    
                    {_renderStepContent(activeStep)}
                
                

                <div style={{ display: 'flex', justifyContent: 'end', marginTop: 25}}>
                    
                    
                </div>
                </Form>
            </Card>
            
            </Formik>
        </Box>
    )
}
